module.exports = __webpack_public_path__ + "static/media/thyferra.5ffac1b5.jpeg";